import defaultConfig from "../../src/config/default.json";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export const toReadableFormat = name => {
    if (!name) return null;
    const underscore = "_";
    let output = "";
    const upperCaseCharCodeStartRange = 65;
    const upperCaseCharCodeEndRange = 90;
    const lowerCaseCharCodeStartRange = 97;
    const lowerCaseCharCodeEndRange = 122;
    for (let index = 0; index < name.length; index++) {
        if (index === 0) {
            output += name[index].toUpperCase();
            // removing underscore, inserting space and converting next letter as upper case to follow camel case
        } else if (name[index] === underscore) {
            output += " ";
            output += name[++index].toUpperCase();
        } else {
            output += name[index].toLowerCase();
            // Inserting space to make more sense while reading(only when these keywords were following camel case)
            if (
                name.charCodeAt(index + 1) >= upperCaseCharCodeStartRange &&
                name.charCodeAt(index + 1) <= upperCaseCharCodeEndRange &&
                name.charCodeAt(index) >= lowerCaseCharCodeStartRange &&
                name.charCodeAt(index) <= lowerCaseCharCodeEndRange
            ) {
                output += " ";
            }
        }
    }
    return output;
};
export const sort = ({ data, key = null, type }) => {
    let tempData = data;
    if (type === defaultConfig.order.type.ascending) {
        tempData = data.sort(function (a, b) {
            var keyA = a[key],
                keyB = b[key];
            if (keyA < keyB) {
                return -1;
            }
            if (keyA > keyB) {
                return 1;
            }
            return 0;
        });
    } else if (type === defaultConfig.order.type.descending) {
        tempData = data.sort(function (a, b) {
            var keyA = a[key],
                keyB = b[key];
            if (keyA < keyB) {
                return 1;
            }
            if (keyA > keyB) {
                return -1;
            }
            return 0;
        });
    }
    return tempData;
};
export const areRequiredFieldsPresent = (...args) => {
    const params = args[0];
    const missingKeys = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const key in params) {
        if (!(params[key] || params[key] === 0)) {
            missingKeys.push(key);
        }
    }
    if (missingKeys.length) {
        // eslint-disable-next-line no-throw-literal
        throw {
            status: 400,
            message: `Param '${missingKeys.join()}' ${missingKeys.length === 1 ? "is" : "are"} required`,
        };
    }
    return true;
};
export const createObjectOnBehalfOfGivenKey = ({ arr, key }) => {
    areRequiredFieldsPresent({ arr, key });
    const obj = {};
    if (arr.length) {
        for (const iterator of arr) {
            obj[iterator[key]] = iterator;
        }
    }
    return obj;
};

export const roundOff = (amount, toFixed = 2) => {
    let resp = 0;
    if (amount) {
        resp = Math.round(10 * amount.toFixed(toFixed)) / 10;
    }
    return resp;
};

export const getHoldingNetPercentChange = ({ data }) => {
    areRequiredFieldsPresent({ data });
    areRequiredFieldsPresent({ average_price: data.average_price, last_price: data.last_price });
    return roundOff(((data.last_price - data.average_price) / data.average_price) * 100);
};

export const executeFunction = async ({ reference, body, query }) => {
    try {
        const executionResp = await reference(body, query);
        if (executionResp) {
            toastMessage({ message: `${toReadableFormat(reference.name)} success`, type: "success" });
        }
        return executionResp;
    } catch (e) {
        toastMessage({
            message: `An error has occurred in ${toReadableFormat(reference.name)}, ${e}`,
            type: "error",
        });
    }
};

export const toastMessage = ({ message, type }) => {
    areRequiredFieldsPresent({ message });
    const configureObject = {
        error: toast.error,
        warn: toast.warn,
        info: toast.info,
        success: toast.success,
    };
    const toastObjectForRespectiveType = configureObject[type] || toast;
    return toastObjectForRespectiveType(toReadableFormat(message), {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};
